// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 216 ? "vendors" : chunkId) + "." + {"77":"e6a126f2","170":"2f56d822","216":"99d8e2e2"}[chunkId] + ".js";
};